import { useEffect } from 'react';
import { useErrorContext } from 'context/errorContext';
import { useGetStudentsCompletedMakesByUnitIdQuery } from 'services/api/makesApi/makesApi';
const useGetStudentsCompletedMakesByUnitId = (unitId) => {
  const { handleError } = useErrorContext();
  const {
    data,
    error: useGetStudentsCompletedMakesByUnitIdError,
    isLoading,
  } = useGetStudentsCompletedMakesByUnitIdQuery(
    { unitId },
    {
      skip: !unitId,
    }
  );
  useEffect(() => {
    if (useGetStudentsCompletedMakesByUnitIdError)
      handleError(useGetStudentsCompletedMakesByUnitIdError);
  }, [useGetStudentsCompletedMakesByUnitIdError]);

  return { data, isLoading };
};

export default useGetStudentsCompletedMakesByUnitId;
